import { Box, lgBumps, xlBumps } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import { TKeyBuilder } from '../../../../infrastructure/internationalisation'
import { useFormElements } from '../../../../state'
import { FormConfig, InputRepeaterConfig } from '../../../../state/configuration'
import { isInputConfig } from '../../config'
import { FormItems } from '../FormItems'
import { InputRepeaterHeader } from './InputRepeaterHeader'
import { InputRepeaterSummary } from './InputRepeaterSummary'

export * from './InputRepeaterMeta'

export interface InputRepeaterProps {
  item: InputRepeaterConfig
  config: FormConfig
  t: TFunction
  tKey: TKeyBuilder
  errorClassName?: string
}

export const InputRepeater: FunctionComponent<InputRepeaterProps> = ({
  item,
  t,
  tKey,
  errorClassName,
}) => {
  const { name, meta } = item

  const { control } = useFormContext()
  const { fields } = useFieldArray({
    control,
    name,
  })

  const formElements = useFormElements(meta?.formFields)
  const [headerElement, ...summaryElements] = useFormElements(meta?.summaryFields).filter(
    isInputConfig,
  )

  return fields.length ? (
    <Box width={1} display='flex' flexDirection='column' rowGap={xlBumps}>
      {fields.map((field, index) => (
        <Box
          key={field.id}
          display='flex'
          flexDirection='column'
          width={1}
          rowGap={lgBumps}
        >
          <InputRepeaterHeader
            element={headerElement}
            value={field[headerElement.name]}
            t={t}
          />

          <InputRepeaterSummary elements={summaryElements} values={field} t={t} />

          <FormItems
            t={t}
            tKey={tKey}
            config={formElements}
            prefix={[item.name, index].join('.')}
            errorClassName={errorClassName}
          />
        </Box>
      ))}
    </Box>
  ) : null
}
